export default class WaitlistSize {
  constructor(size, sku) {
    this.node = document.createElement('span');
    this.node.classList.add('WaitlistModal__size');
    this.node.innerText = size;
    this.node.setAttribute('data-sku', sku);

    // Activate and deactivate size selection
    this.node.addEventListener('click', () => {
      this.node.classList.toggle('WaitlistModal__size--active');
      // Clean any existing error class
      if (this.node.classList.contains('WaitlistModal__size-error')) {
        this.node.classList.remove('WaitlistModal__size-error');
      }
    });
  }
}
